const initialState = {
    type:'fixed'
  };
  
  const subSchemeReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case "GET_TYPE":
        return {
          ...state,
          type: payload,
        };
  
      default:
        return state;
    }
  };

  export default subSchemeReducer;
  
